import { ASYNC_PVP_LOBBY_EXPIRY_HOURS } from '../constants/pvpLobby';

/** API stores `PublishedAt` as UTC; JSON may omit `Z` — parse as UTC so the lobby countdown matches the server (48h). */
export function parsePvPRoomPublishedAtUtcMs(iso: string | null | undefined): number | null {
  const raw = iso?.trim();
  if (!raw) return null;
  const hasZone = /[zZ]$|[+-]\d{2}:?\d{2}$/.test(raw);
  const forParse = hasZone ? raw : `${raw}Z`;
  const ms = Date.parse(forParse);
  return Number.isNaN(ms) ? null : ms;
}

/** Remaining time until PublishedAt + 48h; null if not applicable or invalid date. */
export function getAsyncLobbyExpiryRemainingLabel(
  publishedAt: string | null | undefined,
  status: string
): string | null {
  if (status !== 'AwaitingOpponent' || !publishedAt?.trim()) return null;
  const startMs = parsePvPRoomPublishedAtUtcMs(publishedAt);
  if (startMs == null) return null;
  const expiryMs = startMs + ASYNC_PVP_LOBBY_EXPIRY_HOURS * 60 * 60 * 1000;
  const rem = expiryMs - Date.now();
  if (rem <= 0) return '0:00:00';
  const totalS = Math.floor(rem / 1000);
  const h = Math.floor(totalS / 3600);
  const m = Math.floor((totalS % 3600) / 60);
  const s = totalS % 60;
  return `${h}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
}
